import * as Tone from 'tone';
import AudioEffect from './AudioEffect';
class EQ3 extends AudioEffect {
    constructor() {
        super();
        this.eq = new Tone.EQ3();
    }
    input() { return this.eq; }
    output() { return this.eq; }
    get low() {
        return this.eq.low;
    }
    get mid() {
        return this.eq.mid;
    }
    get high() {
        return this.eq.high;
    }
    get Q() {
        return this.eq.Q;
    }
    get lowFrequency() {
        return this.eq.lowFrequency;
    }
    get highFrequency() {
        return this.eq.highFrequency;
    }
}
export default EQ3;
//# sourceMappingURL=EQ3.js.map